import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { Pie, PieChart, ResponsiveContainer } from "recharts";
import { getRecentlyRegisteredAccountReport } from "../../redux/actions";
import ReactApexChart from "react-apexcharts";

const BodyWrapper = styled.div`
  height: 220px;
  display: flex;
  width: 96%;
  gap: 20px;
  padding: 30px 30px;

  .cardContainer {
    overflow-x: hidden;
    overflow-y: hidden;
    position: relative;
    background-color: white;
    /* display: flex; */
    height: 220px;
    /* align-items: center; */
    /* justify-content: center; */
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);

    .flexContainer {
      display: flex;
      align-items: center;
      height: 100%;

      .chartContainer {
        width: 55%;
        position: relative;
        display: flex;
        justify-content: flex-end;
        padding-right: 50px;
        border-right: 1px solid #b3bac0;

        .apexcharts-datalabel-value {
          font-weight: 700;
          font-size: 30px;
          fill: #004576;
        }

        .totalValue {
          position: absolute;
          top: 50px;
          color: #004576;
          font-weight: 700;
          font-size: 20px;
          @media only screen and (min-device-width: 1400px) and (max-device-width: 1700px) {
            left: 42%;
          }
          @media only screen and (min-device-width: 1701px) and (max-device-width: 2400px) {
            left: 38%;
          }
          @media only screen and (min-device-width: 2401px) and (max-device-width: 2939px) {
            left: 42%;
          }
          @media only screen and (min-device-width: 2940px) and (max-device-width: 3000px) {
            left: 48%;
          }
        }
      }

      .openInvitationsContainer {
        width: 100%;
      }

      .informationContainer {
        display: flex;
        width: 250px;
        gap: 50px;
        align-items: center;

        .customLegend {
          margin-top: 10px;
          width: 100%;
          text-align: center;
          gap: 20px;
          align-items: center;
          .identifier {
            width: 20px;
            height: 15px;
            border-radius: 3px;
          }

          .name {
            width: 100%;
            color: #004576;
          }

          .value {
            width: 100%;
            font-weight: 700;
            font-size: 40px;
          }
        }
      }
    }

    .bottomInformation {
      position: absolute;
      bottom: 10px;
      left: 198px;
      color: #004576;
      font-weight: 700;
    }

    .marketValueContainer {
      .amount {
        color: #95d3ff;
        font-weight: 800;
        font-size: 36px;
        width: 100%;
        text-align: center;
      }

      .text {
        font-weight: 400;
        font-size: 14px;
        color: #004576;
        text-align: center;
      }
    }

    .recentlyFundedContainer {
      display: flex;
      padding: 0px 30px;
      align-items: center;
      justify-content: center;
      height: 100%;

      .accounts {
        width: 100%;
        position: relative;

        .listHeader {
          display: flex;
          width: 100%;

          .clientName {
            width: 50%;
          }
          .date {
            width: 50%;
            text-align: right;
          }
        }

        .listOfAccountsScrollable {
          display: flex;
          margin-top: 10px;
          .clientName {
            color: #008ef2;
            width: 50%;
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          .date {
            width: 50%;
            text-align: right;
          }
        }

        .arrowButtonContainer {
          display: flex;
          .blankSpace {
            width: 50%;
          }
          .icon {
            width: 50%;
            text-align: center;
            cursor: pointer;
          }
        }

        .bottomtext {
          position: absolute;
          font-weight: 700;
          font-size: 16px;
          color: #004576;
        }
      }
      .incoming {
        width: 50%;
        position: relative;

        .incomingCount {
          width: 100%;
          color: #008ef2;
          font-weight: 800;
          font-size: 40px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .bottomtext {
          position: absolute;
          font-weight: 700;
          font-size: 16px;
          color: #004576;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
`;

const IncomingAdvisorAnalyticsChartsContainer = ({
  clientTypeReport,
  openInvitations,
}) => {
  const { recentlyRegisteredAccount } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [clientTypeReportState, setClientTypeReportState] = useState([]);
  const [recentlyFundedPageNumber, setRecentlyFundedPageNumber] = useState(1);
  const [colors, setColors] = useState(["#004576", "#48C8F4"]);

  const chartData = {
    options: {
      chart: { type: "donut" },
      legend: { show: false },
      dataLabels: { enabled: false },
      tooltip: { enabled: false },
      fill: { colors: ["#004576", "#48C8F4"] },
      states: {
        hover: { filter: { type: "none" } },
        active: { filter: { type: "none", value: 1 } },
      },
      stroke: { width: 0 },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "75%",
            labels: {
              show: true,
              name: { show: false },
              total: {
                show: true,
                showAlways: true,
              },
            },
          },
        },
      },
    },
  };

  useEffect(() => {
    if (clientTypeReport?.hasOwnProperty("reportPie")) {
      let temp = [];
      clientTypeReport?.reportPie?.forEach((data, index) => {
        temp.push({
          name: data.label,
          value: data.value,
          fill: colors[
            data.value > clientTypeReport?.reportPie[1]?.value ? 0 : 1
          ],
        });
      });
      setClientTypeReportState(temp);
    }
  }, [clientTypeReport]);

  useEffect(() => {
    dispatch(getRecentlyRegisteredAccountReport(1, 4));
  }, [recentlyFundedPageNumber]);

  return (
    <BodyWrapper>
      <div className="cardContainer" style={{ width: "67%" }}>
        <div className="flexContainer">
          <div className="chartContainer">
            <div className="totalValue">
              {/* {clientTypeReportState.length <= 0
                ? 0
                : clientTypeReportState.length >= 2
                ? parseInt(clientTypeReportState[0]?.value) +
                  parseInt(clientTypeReportState[1]?.value)
                : parseInt(clientTypeReportState[0]?.value)} */}
            </div>
            <ReactApexChart
              options={chartData.options}
              series={[
                parseInt(clientTypeReportState[0]?.value) || 0,
                parseInt(clientTypeReportState[1]?.value) || 0,
              ]}
              type="donut"
            />
            {/* <ResponsiveContainer width={425} height={124}>
              <PieChart width={425} height={124}>
                <Pie
                  data={clientTypeReportState}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  label={false}
                  legendType="none"
                  innerRadius={40}
                  outerRadius={55}
                  fill="#004576"
                />
              </PieChart>
            </ResponsiveContainer> */}
            <div className="informationContainer">
              {clientTypeReportState?.map((data) => (
                <div className="customLegend">
                  <div className="value" style={{ color: data.fill }}>
                    {data.value}
                  </div>
                  <div className="name">{data.name}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="openInvitationsContainer">
            <div>
              <div className="marketValueContainer">
                <div className="amount">{openInvitations || 0}</div>
                <div className="text">Open Invitations</div>
              </div>
            </div>
          </div>
          <div className="bottomInformation">Total</div>
        </div>
      </div>
      <div className="cardContainer" style={{ width: "33%" }}>
        {recentlyRegisteredAccount?.accounts?.length >= 0 && (
          <div className="recentlyFundedContainer">
            <div className="accounts">
              <div
                style={{ fontWeight: 700, fontSize: "16px", color: "#004576" }}
              >
                Recent Registrations{" "}
              </div>
              <div className="listHeader">
                <div className="clientName" style={{ color: "#004576" }}>
                  Email
                </div>
                <div
                  className="date"
                  style={{ color: "#004576", paddingRight: "43px" }}
                >
                  Date
                </div>
              </div>
              {recentlyRegisteredAccount?.accounts &&
                recentlyRegisteredAccount?.accounts?.length >= 0 &&
                recentlyRegisteredAccount?.accounts?.map((data) => (
                  <div className="listOfAccountsScrollable">
                    <div
                      className="clientName"
                      onClick={() => window.open(`mailto:${data.email}`)}
                    >
                      {data.email}
                    </div>
                    <div className="date">{data.fundedDate}</div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </BodyWrapper>
  );
};

export default IncomingAdvisorAnalyticsChartsContainer;
